// extracted by mini-css-extract-plugin
export default {"split":"sidebar_split__Z9FFi","active":"sidebar_active__-IKph"};